var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61364 8.35682C4.59191 8.37383 4.57433 8.39556 4.56224 8.42036C4.55016 8.44517 4.54388 8.4724 4.54388 8.5C4.54388 8.5276 4.55016 8.55483 4.56224 8.57964C4.57433 8.60444 4.59191 8.62617 4.61364 8.64318L7.83409 11.1886C7.95227 11.2818 8.12727 11.1977 8.12727 11.0455L8.12727 9.36136L15.8182 9.36136C15.9182 9.36136 16 9.27955 16 9.17955L16 7.81591C16 7.71591 15.9182 7.63409 15.8182 7.63409L8.12955 7.63409L8.12955 5.95455C8.12955 5.80227 7.95455 5.71818 7.83636 5.81136L4.61364 8.35682ZM5.40909 16.8182L5.40909 15.4545C5.40909 15.3545 5.32727 15.2727 5.22727 15.2727L1.72727 15.2727L1.72727 1.72727L5.22727 1.72727C5.32727 1.72727 5.40909 1.64545 5.40909 1.54545L5.40909 0.181818C5.40909 0.0818177 5.32727 -4.6652e-07 5.22727 -4.70891e-07L0.727274 -6.67592e-07C0.325001 -6.85176e-07 9.39468e-07 0.324999 9.21884e-07 0.727272L2.42371e-07 16.2727C2.24787e-07 16.675 0.325 17 0.727273 17L5.22727 17C5.32727 17 5.40909 16.9182 5.40909 16.8182Z",
    fill: "#02274B",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signout-icon.c8cc5c058e1afea43f28b1e888a5a818.svg";
export { ForwardRef as ReactComponent };